import(/* webpackMode: "eager", webpackExports: ["ContactPageClient"] */ "/app/app/[locale]/contact/contact-page-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
